class DataviewService {
    /**
     * @param {ManagerAppData.IEmployee[]} employees
     * @param {string} searchValue
     * @returns {ManagerAppData.IEmployee[]}
     */
    searchInDataviews(employees, searchValue) {
        if (!searchValue) {
            return employees;
        }

        /** @type {(employee: ManagerAppData.IEmployee) => string} */
        const searchableEmployee = (employee) =>
            `${employee.employeeName}${[...employee.dataviewAttributes.map((y) => y.rawValue)]}`.toLocaleLowerCase();
        const filteredEmployees = employees.filter((employee) =>
            searchableEmployee(employee).toLocaleLowerCase().includes(searchValue.toLocaleLowerCase()));
        return filteredEmployees;
    }
}

export default (new DataviewService());
